import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component export class ManualSwitcher extends ThemeComponent {
    @Ref() selectedCountryTrigger!: HTMLButtonElement;
    @Ref() confirmSelection!: HTMLButtonElement;
    @Ref() closeTrigger!: HTMLButtonElement;
    @Ref() manualSwitcherOverlay!: HTMLDivElement;
    @Ref() countryContainer!: HTMLDivElement;
    @Ref() countryList!: HTMLDivElement;
    @Ref() countryUpdated!: HTMLLIElement[];

    /**
        * Initialise.
    **/
    init() {
        this.$log.debug(this.$name, 'Initing');
        this.confirmSelection.addEventListener('click', () => this.loadStore());

        this.$listen(this.closeTrigger, 'click', () => this.closeSwitcher());
        this.$listen(this.selectedCountryTrigger, 'click', () => this.toggleList());
        this.$listen(this.manualSwitcherOverlay, 'click', () => this.closeSwitcher());

        document.addEventListener('toggleSwitcher', () => {
            this.toggleSwitcher();
        });

        for (const countryUpdated of this.countryUpdated) {
            this.$listen(countryUpdated, 'click', () => this.updateList(countryUpdated));
        }
    }

    /**
        * Show / Hide Modal
    **/
    toggleSwitcher() {
        this.countryContainer.classList.toggle('visually-hidden');
        this.countryContainer.classList.toggle('is-active');
        this.manualSwitcherOverlay.classList.toggle('visually-hidden');
        document.body.classList.add('drawer-open');
    }

    /**
        * Show / Hide Country List
    **/
    toggleList() {
        this.selectedCountryTrigger.classList.toggle('is-active');
        this.countryList.classList.toggle('is-active');
    }

    /**
        * Update Selected Country
        * Selected label is updated with new selection
        * Selected country in the list is marked as currently selected - css to indicate
    **/
    updateList(countryUpdateTrigger: HTMLLIElement) {
        this.resetList();
        this.selectedCountryTrigger.innerHTML = countryUpdateTrigger.innerHTML;
        this.selectedCountryTrigger.dataset.storeUrl = countryUpdateTrigger.dataset.storeUrl;
        countryUpdateTrigger.classList.add('is-selected');
        this.toggleList();
    }

    /**
        * Reset Country List
        * Removes previous country selection
    **/
    resetList() {
        for (const countryUpdated of this.countryUpdated) {
            if (countryUpdated.classList.contains('is-selected')) {
                countryUpdated.classList.remove('is-selected');
            }
        }
    }

    /**
        * Update Confirm CTA
        * If new country selection matches current store domain, just close instead of triggering redirect
    **/
    loadStore() {
        const currentDomain = window.location.hostname;
        const newDomain = this.selectedCountryTrigger.dataset.storeUrl;

        if (!newDomain?.includes(currentDomain)) {
            window.location.href = `${this.selectedCountryTrigger.dataset.storeUrl}`;
        } else {
            this.closeSwitcher();
        }
    }

    /**
        * Close Modal
        * Resets any changes / selections and closes the modal
    **/
    closeSwitcher() {
        this.resetList();
        this.selectedCountryTrigger.innerHTML = this.countryUpdated[0].innerHTML;
        this.countryContainer.classList.add('visually-hidden');
        this.countryContainer.classList.remove('is-active');
        this.countryList.classList.remove('is-active');
        this.selectedCountryTrigger.classList.remove('is-active');
        this.manualSwitcherOverlay.classList.add('visually-hidden');
        document.body.classList.remove('drawer-open');
    }
}
